import Reveal from "@/components/7fcc/Reveal";
import SectionHeader from "@/components/7fcc/SectionHeader";
import { OPPORTUNITY } from "@/data/content";

// The opportunity: 3 benefit boxes + 3 numbered steps, in 7FCC styling.
export default function OpportunitySection() {
  return (
    <section className="bg-ink-900 px-6 py-16 md:py-24" data-testid="opportunity-section">
      <div className="mx-auto max-w-5xl">
        <SectionHeader
          center
          eyebrow={OPPORTUNITY.eyebrow}
          title={OPPORTUNITY.headline}
          support={OPPORTUNITY.intro}
          testId="opportunity-heading"
        />

        <div className="mt-10 grid gap-5 md:grid-cols-3 md:mt-12">
          {OPPORTUNITY.cards.map((card, i) => (
            <Reveal key={card.title} delay={i * 0.08} className="h-full">
              <div
                className="h-full rounded-lg border border-line bg-ink-950/60 p-6"
                data-testid={`opportunity-card-${i + 1}`}
              >
                <h3 className="font-display text-lg font-medium text-fg">{card.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-fg-muted">{card.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-5 grid gap-5 md:grid-cols-3">
          {OPPORTUNITY.steps.map((step, i) => (
            <Reveal key={step.title} delay={i * 0.08} className="h-full">
              <div
                className="flex h-full items-start gap-4 rounded-lg border border-line bg-ink-950/60 p-6"
                data-testid={`opportunity-step-${i + 1}`}
              >
                <span
                  className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand text-xs font-bold text-white"
                  aria-hidden="true"
                >
                  {i + 1}
                </span>
                <div>
                  <h3 className="font-display text-base font-medium text-fg">{step.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-fg-muted">{step.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
